import {
  faBuilding,
  faFileInvoiceDollar,
  faHandshake,
  faHouseBuilding,
  faListCheck,
  faSquareCheck,
  faUser,
} from '@fortawesome/pro-regular-svg-icons';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface CardTheme {
  icon: IconDefinition;
  tileClassName: string;
}

export const CARD_THEMES = {
  activity: { icon: faListCheck, tileClassName: 'bg-storm-grey-100 text-storm-grey-700' },
  contact: { icon: faUser, tileClassName: 'bg-purple-heart-100 text-purple-heart-700' },
  deal: { icon: faHandshake, tileClassName: 'bg-mountain-meadow-100 text-mountain-meadow-700' },
  listing: { icon: faBuilding, tileClassName: 'bg-buildout-blue-100 text-buildout-blue-700' },
  property: { icon: faHouseBuilding, tileClassName: 'bg-buildout-blue-100 text-buildout-blue-700' },
  task: { icon: faSquareCheck, tileClassName: 'bg-harvest-gold-100 text-harvest-gold-700' },
  voucher: { icon: faFileInvoiceDollar, tileClassName: 'bg-seagull-100 text-seagull-700' },
} satisfies Record<string, CardTheme>;
